module.exports = __webpack_public_path__ + "img/kangmingjian_img4.3f0e9f3d.jpg";